
export class InformacioTramitador {

  countImages: number;

  constructor() {
    this.countImages = 0;
  }
}
